import { HUB } from 'constants/hubs';

export const isAuHub = (hub) => {
  return hub === HUB.FUSION_MARKETS;
};

export const isEnHub = (hub) => {
  return hub === HUB.FUSION_MARKETS_X;
};

export const isCyHub = (hub) => {
  return hub === HUB.FUSION_MARKETS_EU || hub === HUB.FUSION_MARKETS_CY; //TODO remove EU when FMGP FDS-3902 will be deployed on prod
};
